export function formatAmount(
  value: number,
  { maximumFractionDigits = 0 } = {}
) {
  return new Intl.NumberFormat('sk-SK', {
    currency: 'EUR',
    style: 'currency',
    maximumFractionDigits,
  }).format(value)
}

export function formatNumberWithSpaces(number: number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
